<template>
  <div id="cart-details" class="bg-gray">

    <section id="cart-summary-items">
      <div class="container">
        <cart-items-list :view-mode="'summary'"></cart-items-list>
      </div>
    </section>

    <section id="shipment" class="bg-gray">
      <div class="container">
        <div class="cart-row">
          <div class="row-label"><p v-html="getTranslatedName('shipping')"></p></div>
        </div>
        <div class="cart-row">
          <div class='label'><p v-html="getTranslatedName(shipment.internal_name)"></p></div>
          <div><p class='cart-price amount' v-html="getPrice(shipment.cost/100)"></p></div>
        </div>
      </div>
    </section>

    <section id="addresses" class="bg-gray">
      <div class="container">
        <div class="cart-row">
          <display-address type="billing"></display-address>
          <display-address type="shipping"></display-address>
        </div>
      </div>
    </section>

    <section id="discount" class="bg-gray" v-if="hasDiscount">

      <div class="container">
        <div class="cart-row">
          <div class="label">Naliczony rabat</div>
          <div class="cart-price amount" v-html="getPrice(discountValue)"></div>
        </div>
      </div>
    </section>

    <section id="total-summary" class="bg-gray">
      <div class="container">
        <div class="cart-row summary">
          <p v-translate="'CART_order_total'">Kwota do zapłaty</p>
          <h3 class="cart-price amount" v-html="getPrice(orderTotal)"></h3>
        </div>
      </div>
    </section>

    <section id="comment" class="bg-gray">
      <div class="container">
        <div class="cart-row">
          <div class="row-label" style="border: none"><p v-html="getTranslatedName('comment')"></p></div>
          <textarea id="order-comment" v-model="comment" v-on:blur="commented()"></textarea>
        </div>

      </div>
    </section>

    <payments v-on:payment="ChangePayment"></payments>

    <section id="approvals" class="bg-gray">
      <div class="container">
        <div class="cart-row">
          <div class="row-label"><p>&nbsp;</p></div>
        </div>
        <div class="cart-row approvals-checkmarks">
          <div>
            <p>
              <label class="form-item">
                <input type="checkbox" v-model="approvals.regulation">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedRegulations')"></span>
              </label>
            </p>
            <p
              v-if="approvals.approvalType == 'paribas10' || approvals.approvalType == 'paribas20' || approvals.approvalType == 'paribas30'">
              <label class="form-item">
                <input type="checkbox" v-model="approvals.installment_regulations">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedInstallmentRegulations')"></span>
              </label>
            </p>
            <p
              v-if="approvals.approvalType == 'paribas10' || approvals.approvalType == 'paribas20' || approvals.approvalType == 'paribas30'">
              <label class="form-item">
                <input type="checkbox" v-model="approvals.installment_regulations_2">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedInstallmentRegulations2')"></span>
              </label>
            </p>
            <p v-if="approvals.approvalType == 'paribas10' || approvals.approvalType == 'paribas20'">
              <label class="form-item">
                <input type="checkbox" v-model="approvals.installment_10">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedInstallment10')"></span>
              </label>
            </p>
            <p v-if="approvals.approvalType == 'paribas30'">
              <label class="form-item">
                <input type="checkbox" v-model="approvals.installment_30">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedInstallment30')"></span>
              </label>
            </p>

            <p>
              <label class="form-item">
                <input type="checkbox" v-model="approvals.privacy">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedPrivacy')"></span>
              </label>
            </p>
            <p>
              <label class="form-item">
                <input type="checkbox" v-model="approvals.information">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedInformation')"></span>
              </label>
            </p>
            <p>
              <label class="form-item">
                <input type="checkbox" v-model="approvals.marketing">
                <span class="checkmark"></span>
                <span v-html="getTranslatedName('approvedMarketing')"></span>
              </label>
            </p>
          </div>
        </div>
        <div class="cart-row">
          <p class="small">* - zgoda wymagana</p>
        </div>
      </div>
    </section>

    <section id="navi-buttons" class="bg-gray">
      <div class="container">
        <div class="cart-row">
          <div class="continue">
            <div class="arrow-left"></div>
            <a :href="getBack()" v-translate="'back'">Wstecz</a></div>

          <button v-if="approvals.approvalType == 'paribas10' || approvals.approvalType == 'paribas20'"
                  @click="redirectFinalize()" class="btn mint"
                  v-bind:disabled="!hasPayment || !approvals.installment_regulations || !approvals.installment_regulations_2 || !approvals.installment_10 || !approvals.regulation"
                  v-translate="'CART_btn_buy'"></button>

          <button v-else-if="approvals.approvalType == 'paribas30'"
                  @click="redirectFinalize()" class="btn mint"
                  v-bind:disabled="!hasPayment || !approvals.installment_regulations || !approvals.installment_regulations_2 || !approvals.installment_30 || !approvals.regulation"
                  v-translate="'CART_btn_buy'"></button>

          <button v-else @click="redirectFinalize()" class="btn mint"
                  v-bind:disabled="!hasPayment || !approvals.regulation"
                  v-translate="'CART_btn_buy'"></button>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

  import CartItemsList from './CartItemsList';
  import Payments from "./Payments";
  import store from "./../../store/index"
  import DisplayAddress from "./DisplayAddress";
  import axios from 'axios';

  export default {
    name: "Summary",
    mounted() {
      store.dispatch('loadAddresses');
      store.dispatch('loadComment');
    },
    components: {CartItemsList, Payments, DisplayAddress},
    data() {
      return {
        hasPayment: false,
        approvals: {
          'approvalType': '',
          'regulation': false,
          'privacy': false,
          'information': false,
          'marketing': false,
          'installment_regulations': false,
          'installment_regulations_2': false,
          'installment_10': false,
          'installment_30': false,
        },
        commentModel: ""
      }
    },
    created() {
    },
    computed: {

      comment: {
        get() {
          return store.getters.comment;
        },
        set(value) {
          this.commentModel = value;
        }
      },
      discountValue() {
        return store.getters.discountValue;
      },
      itemsTotal() {
        return store.getters.itemsTotal;
      },
      payment() {
        return store.getters.payment;
      },
      discount() {
        return store.getters.discount;
      },
      shipment() {
        return store.getters.shipment;
      },
      hasDiscount() {
        if (null !== this.discount) {
          if (typeof this.discount === 'object') {
            if ('id' in this.discount) {

              return true;
            }
          }
        }
        return false;
      },


      orderTotal() {
        let total = this.itemsTotal;
        let shipmentCost = store.getters.shipmentCost / 100;
        total += shipmentCost;
        if (this.discountValue > total) {
          total = 0;
        } else {
          total -= this.discountValue
        }

        return total;
      },
    },


    methods: {
      clearApprovals() {
        this.approvals = {
          'regulation': false,
          'privacy': false,
          'information': false,
          'marketing': false,
          'installment_regulations': false,
          'installment_regulations_2': false,
          'installment_10': false,
          'installment_30': false,
        };
      },
      ChangePayment(e) {
        this.hasPayment = true;
        this.clearApprovals();
        switch (e) {
          //Przelew bakowy
          case 'bankTransfer':
            this.approvals.approvalType = 'basic';
            break;
          //PayU
          case 'payu':
            this.approvals.approvalType = 'basic';
            break;
          //PayU
          case 'paribas10':
            this.approvals.approvalType = 'paribas10';
            break;
          //PayU
          case 'paribas20' :
            this.approvals.approvalType = 'paribas20';
            break;
          //PayU
          case 'paribas30' :
            this.approvals.approvalType = 'paribas30';
            break;
          default:
            this.approvals.approvalType = 'basic';
            break;
        }
      },
      commented() {
        if (this.commentModel.length > 0) {
          store.dispatch('saveComment', this.commentModel);
        }
      },

      getBack() {
        return window.env.baseUrl + window.translations['rt_user_address'];
      },
      getTranslatedName(name) {
        if (typeof window.translations['CART_' + name] !== 'undefined')
          return window.translations['CART_' + name];
        return name;
      },
      redirectFinalize() {
        store.dispatch('setApproved', this.approvals);
        setTimeout(function(){
          window.location.href = window.env.baseUrl + window.translations['rt_shop_finalize'];
        }, 1000);


      },
      getPrice(price) {
        return this.$options.filters.full_price(price);
      },
    }
  }

</script>




// WEBPACK FOOTER //
// src/components/Cart/Summary.vue